import { errorTracker } from 'Modules/event';
import { isActionMarkedAsHandled, unmarkActionAsHandled } from '../services/actionMarker';
import actions from '../actions';

export default (store) => (next) => (action) => {
  if (!action.error) {
    return next(action);
  }

  let nextReturn;

  try {
    nextReturn = next(action);
  } catch (e) {
    errorTracker.captureError(e, { context: action, type: 'reducer' });
  }

  if (!isActionMarkedAsHandled(action)) {
    unmarkActionAsHandled(action);
    const error = action.payload.error || action.payload;
    store.dispatch(actions.throwGlobalError(error));
  }

  return nextReturn;
};
